import { AudioInputState, AudioInputStateCover } from "@/types/defs/audioInput";
import { isSelectedCover } from "@/utils/selectedFileCover/is/isSelectedCover";

export const isAudioInputCover = (
  audioInput: AudioInputState
): audioInput is AudioInputStateCover => {
  const selectedFileCover = audioInput.selectedFileCover;
  return selectedFileCover !== null && isSelectedCover(selectedFileCover);
};
